import React from 'react'

/** Case-insensitive substring highlight for search result previews. */
export function highlightSearchQuery(text: string, query: string): React.ReactNode {
  const needle = query.trim()
  if (!needle || !text) return text

  const escaped = needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp(`(${escaped})`, 'gi')
  const parts = text.split(regex)

  if (parts.length === 1) return text

  return parts.map((part, index) => {
    if (!part) return null
    if (part.toLowerCase() === needle.toLowerCase()) {
      return (
        <mark
          key={`${index}-${part}`}
          className="rounded-sm bg-brand-primary-subtle px-0.5 text-text-primary"
        >
          {part}
        </mark>
      )
    }
    return <React.Fragment key={`${index}-${part}`}>{part}</React.Fragment>
  })
}
